<div class="modal-header">
    <h4 class="modal-title fw-bold">{{title | translate}}</h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="closeModal()"></button>
</div>
<div class="modal-body" data-test="treeTableModalBody">
    <div *ngIf="!this.isReadOnly" class="row mb-3 modal-popover ">
        <div class="col-md-7">
        </div>
        <div class="col-md-5">
            <div class="float-end">
                <img (click)="setMode(Modes.Add, $event)" src="content/images/add2.png" class=""
                     [ngClass]="{ 'disable-image': this.isAddActionDisabled() }" [attr.title]="this.isAddActionDisabled() ? this.disabledAddActionMessage : ''"/>
                <img (click)="setMode(Modes.Rename, $event)" src="content/images/edit.png" class="ps-1"
                     [ngClass]="{ 'disable-image': this.isRenameActionDisabled() }" [attr.title]="this.isRenameActionDisabled() ? this.disabledRenameActionMessage : ''"/>
                <img (click)="setMode(Modes.Delete, $event)" src="content/images/delete.png" class="ps-1"
                     [ngClass]="{ 'disable-image': this.isDeleteActionDisabled() }" [attr.title]="this.isDeleteActionDisabled() ? this.disabledDeleteActionMessage : ''"/>
            </div>
        </div>
    </div>
    <div class="row mb-3">
        <div class="col-xs-12 col-md-12">
            <div *ngIf="!this.isReadOnly" class="form-horizontal mb-3">
                <div id="addFolderDiv" *ngIf="mode == Modes.Add || mode == Modes.Rename">
                    <div class="mb-3 row">
                        <div class="col-3">
                            <label class="fw-bold">{{ 'common.folder.action.' + Modes[mode].toString().toLowerCase() | translate }}</label>
                        </div>
                        <div class="col-9">
                            <div class="input-group">
                                <input type="text" class="form-control" placeholder="{{ 'common.folder.name' | translate }}" [(ngModel)]="this.name" jhi-forbiddenCharactersValidator [required]="true"  maxlength="{{ NAME_MAX_LENGTH }}"/>
                                <button class="btn btn-success" [title]="'common.folder.title.' + Modes[mode].toString().toLowerCase() | translate" [disabled]="containsForbiddenCharacters(name)" (click)="submitAddOrRenameFolder()">
                                    <span class="fa fa-check"></span>
                                </button>
                                <button class="btn btn-danger" title="{{ 'common.form.cancel.text' | translate }}" (click)="mode = Modes.None">
                                    <span class="fa fa-times"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
            <div class="clearfix"></div>
            <div class="table-responsive custom-scroll-style" style="max-height: 800px; overflow-y: auto;">
                <p-treeTable [value]="nodes"
                             (onNodeExpand)="onNodeExpand($event)"
                             [selectionMode]="selectionMode"
                             [autoLayout]="true"
                             [(selection)]="this._selectedNodes"
                             (onNodeSelect)="onNodeSelect($event)"
                             styleClass="tree-table">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>{{'study.treetable.column.name' | translate}}</th>
                            <th>{{'study.treetable.column.owner' | translate}}</th>
                            <th>{{'study.treetable.column.locked' | translate}}</th>
                            <th>{{'study.treetable.column.description' | translate}}</th>
                            <th>{{'study.treetable.column.type' | translate}}</th>
                            <th>{{'study.treetable.column.no.of.entries' | translate}}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-i="rowIndex">
                        <tr [ttSelectableRow]="rowNode">
                            <td>
                                <div class="d-flex align-items-center">
                                    <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                                    <span [ngClass]="{ 'folder': !rowNode.node.leaf, 'file': rowNode.node.leaf }"></span>
                                    <span *ngIf="this.isReadOnly || rowData.isLocked">{{translateName(rowData)}}</span>
                                    <span *ngIf="!this.isReadOnly && !rowData.isLocked"
                                          pDraggable="treedragdrop"
                                          pDroppable="treedragdrop"
                                          (onDragStart)="onDragStart($event, rowNode.node)"
                                          (onDragEnd)="onDragEnd($event, rowNode.node)"
                                          (onDrop)="onDrop($event, rowNode.node)"
                                          (onDragEnter)="onDragEnter($event, rowNode.node)"
                                          (onDragLeave)="onDragLeave($event, rowNode.node)"
                                          type="text">
											{{translateName(rowData)}}
									</span>
                                </div>

                            </td>
                            <td>{{rowData.owner}}</td>
                            <td>{{rowNode.node.leaf ? ((rowData.isLocked ? 'yes' : 'no') | translate) : ''}}</td>
                            <td><truncate-span [textInput]="rowData.description" [maxLength]="20"></truncate-span></td>
                            <td>{{rowData.type}}</td>
                            <td>{{rowData.noOfEntries}}</td>
                        </tr>
                    </ng-template>
                </p-treeTable>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="closeModal()" data-test="treeTableCancelButton">{{ 'cancel' | translate}}</button>
    <button *ngIf="showAddToParentList" type="button" class="btn btn-primary" aria-hidden="true" [disabled]="!selectedNodes.length" (click)="addListToParents(true)">{{ 'common.add.to.female.list' | translate}}</button>
    <button *ngIf="showAddToParentList" type="button" class="btn btn-primary" aria-hidden="true" [disabled]="!selectedNodes.length" (click)="addListToParents(false)">{{ 'common.add.to.male.list' | translate}}</button>
    <button *ngIf="showAddToParentList" type="button" class="btn btn-primary" aria-hidden="true" [disabled]="!selectedNodes.length" (click)="finish()">{{ 'common.open.for.review' | translate}}</button>
    <button *ngIf="!showAddToParentList" type="button" class="btn btn-primary" aria-hidden="true" [disabled]="!selectedNodes.length" (click)="finish()" data-test="treeTableOkButton">{{ 'ok' | translate}}</button>
</div>
